(() => {
  if (window.__tanCartDecisionV35) return;
  window.__tanCartDecisionV35 = true;

  const sent = new Set();
  const publish = (name, data = {}, onceKey = '') => {
    if (onceKey && sent.has(onceKey)) return;
    if (onceKey) sent.add(onceKey);
    const payload = {
      event_version: '1.0',
      language_code: String(document.documentElement.lang || '').slice(0, 20),
      ...data,
    };
    window.dispatchEvent(new CustomEvent('tan:cart-decision-event', { detail: { name, data: payload } }));
    try {
      window.Shopify?.analytics?.publish?.(`the_art_neon:${name}`, payload);
    } catch (_) {
      // Cart and checkout remain fully usable when analytics is unavailable.
    }
  };

  const bind = (root = document) => {
    root.querySelectorAll('[data-tan-cart-proof-link]:not([data-tan-cart-proof-bound])').forEach((link) => {
      link.dataset.tanCartProofBound = 'true';
      link.addEventListener('click', () => {
        const proofType = String(link.dataset.tanCartProofLink || 'unknown').replace(/[^a-z0-9_-]/gi, '').slice(0, 32);
        const position = Math.max(0, Math.min(20, Number(link.dataset.tanProjectPosition || 0)));
        publish('cart_proof_opened', { proof_type: proofType, project_position: position });
      });
    });
  };

  bind();

  const decision = document.querySelector('[data-tan-cart-decision]');
  if (decision && !document.documentElement.classList.contains('shopify-design-mode')) {
    const source = decision.querySelector('[data-tan-cart-review-source]')?.dataset.tanCartReviewSource || 'aggregate';
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        publish('cart_decision_evidence_viewed', { review_source: String(source).slice(0, 24) }, 'cart-decision-view');
        observer.disconnect();
      }, { threshold: 0.2 });
      observer.observe(decision);
    }
  }

  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
